<template>
  <div>
    <LotteriesTable />
    <Base--SideButtons />
  </div>
</template>

<script>
import LotteriesTable from '@/components/common/Table/Lotteries Table/LotteriesTable.vue'

export default {
  components: { LotteriesTable }
}
</script>
